import { Component, forwardRef, Input, model } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { cva, VariantProps } from 'class-variance-authority';

const checkboxVariants = cva('checkbox', {
  variants: {
    variant: {
      primary: 'checkbox--primary',
    },
    size: {
      medium: 'checkbox--medium',
      small: 'checkbox--small',
    },
  },
  defaultVariants: {
    variant: 'primary',
    size: 'medium',
  },
});
type CheckboxVariants = VariantProps<typeof checkboxVariants>;

@Component({
  selector: 'common-checkbox',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() variant: CheckboxVariants['variant'];
  @Input() size: CheckboxVariants['size'];
  public checked = model<boolean>(false);
  @Input() disabled?: boolean = false;
  @Input() ariaLabel?: string;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange = (_) => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouch = (_) => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(checked: boolean) {
    this.checked.set(checked);
  }

  public setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  onModelChange($event) {
    this.checked.set($event && $event.target && $event.target.checked);
    this.onChange(this.checked());
  }

  computedClass() {
    return checkboxVariants({ variant: this.variant, size: this.size });
  }
}
